
// Clone of AskLive Chart

import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import styled, { keyframes } from 'styled-components';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getAuth } from 'firebase/auth';

import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

import AskChartTopicsPropFunding from './AskChartTopicsPropFunding';



const bounce = keyframes`
  0% { transform: scale(1); }
  30% { transform: scale(0.92); }
  60% { transform: scale(1.05); }
  100% { transform: scale(1); }

  
`;







const MessageContainer = styled.div`
  padding: 12px 16px;
  margin-bottom: 10px;
  border-radius: 16px;
  max-width: 80%;
  align-self: ${(props) => (props.sender === 'user' ? 'flex-end' : 'flex-start')};
  background-color: ${(props) => (props.sender === 'user' ? '#007BFF' : '#232830')};
  color: #ffffff;
  font-size: 16px;
  line-height: 1.4;
  text-align: ${(props) => (props.sender === 'user' ? 'right' : 'left')};
`;

const UpgradeContainer = styled.div`
  background-color: #ffffff;
  padding: 20px;
  margin-top: 20px;
  border-radius: 16px;
  color: #232830;
  text-align: center;
`;

const UpgradeButton = styled(Button)`
  background-color: #ff7c24;
  border-color: #ff7c24;
  font-weight: bold;
  border-radius: 12px;
  padding: 10px 20px;
  animation: ${bounce} 0.4s ease;
`;

const StyledSendButton = styled(Button)`
  min-width: 100px;
  min-height: 50px;
  background-color: #ff7c24;
  border-color: #ff7c24;
  color: #ffffff;
  font-weight: bold;
  border-radius: 12px;
  font-size: 16px;
  animation: ${bounce} 0.3s ease;
`;

const formatAIMessage = (text) => {
  return text
    .replace(/---/g, '')
    .replace(/(🗨️\s\*\*Answer\*\*:)/g, '<br /><br />$1')
    .replace(/(🧠\s\*\*Key Insight\*\*:)/g, '<br /><br />$1')
    .replace(/(📊\s\*\*Key Action\*\*:)/g, '<br /><br />$1')
    .replace(/\n{2,}/g, '<br /><br />')
    .replace(/\n/g, '<br />')
    .trim();
};

const AskLiveChartPropFunding = ({
  show,
  onClose,
  instrument = 'BTCUSD',
  charttype = 'live',
  timeframe = '1D',
  chartContextPrompt = '',
}) => {

const [collapsedMessageIndex, setCollapsedMessageIndex] = useState(null);
const [selectedTopicId, setSelectedTopicId] = useState(null);
const [isScrolledUp, setIsScrolledUp] = useState(false);

const handleScroll = (e) => {
  const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  setIsScrolledUp(!bottom);
};


const handleFeedback = async (feedbackType, aiText) => {
  try {
    const db = getFirestore();
    const user = auth.currentUser;
    const userId = user?.uid || 'anonymous';

    await addDoc(collection(db, 'user_ask_the_chart_feedback'), {
      userid: userId,
      chatsessionid: chatSessionIdRef.current,
      feedback: feedbackType,
      airesponse: aiText,
      instrument,
      timeframe,
      charttype,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error('⚠️ Failed to log feedback:', err);
  }
};



const chatEndRef = useRef(null);
const chatSessionIdRef = useRef(null);
useEffect(() => {
  if (show && !chatSessionIdRef.current) {
    chatSessionIdRef.current = uuidv4();
  }
}, [show]);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageCount, setMessageCount] = useState(0);
  const auth = getAuth();
  const MAX_MESSAGES = 4;

  const remainingMessages = MAX_MESSAGES - messageCount;

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;
  
    const userMessage = userInput.trim();
    const userId = auth.currentUser?.uid || 'anonymous';
    const chatSessionId = chatSessionIdRef.current;
    const messageId = messageCount + 1;
  
    const newMessages = [...messages, { sender: 'user', text: userMessage }];
    setMessages(newMessages);
    setUserInput('');
    setLoading(true);



const bounceFlash = keyframes`
  0% { transform: scale(1); }
  25% { transform: scale(1.1); color: #FF4C4C; }
  50% { transform: scale(0.95); }
  75% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;



  
    // Show upgrade panel if limit reached
    if (messageCount + 1 === MAX_MESSAGES) {





      // Show user message in chat and exit early
      setMessages((prev) => [...prev, { sender: 'user', text: userMessage }]);
      setMessageCount((prev) => prev + 1);
      setLoading(false);


      try {
        const db = getFirestore();
        await addDoc(collection(db, 'user_aiagent_ask_the_chart_interactions'), {
          userid: userId,
          chatsessionid: chatSessionId,
          usermessage: userMessage,
          airesponse: '[system] upgrade prompt',
          chartcontext: chartContextPrompt,
          charttype,
          instrument,
          timeframe,
          modelused: 'upgrade-limit',
          messageid: messageId,
          intent: 'ask the chart',
          timestamp: serverTimestamp(),
        });
      } catch (err) {
        console.error('❌ Failed to log upgrade interaction:', err);
      }

      return;
    }
  
    // Show temporary thinking message
    const thinkingMessage = { sender: 'ai', text: 'Analyzing chart...' };
    setMessages((prev) => [...prev, thinkingMessage]);
  
    try {
      const response = await axios.post(
        'https://mcp-server-fintorro.onrender.com/askTheChartAiChat',
        {
          userid: userId,
          chatsessionid: chatSessionId,
          userMessage,
          chartContext: chartContextPrompt,
          instrument: instrument,
          charttype: charttype,
          timeframe: timeframe,
          intent: 'ask the chart',
          messageCount: messageCount,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-aimodel': 'gemini',
          },
        }
      );
  
      const aiReply = response.data?.reply || '⚠️ AI response unavailable.';
  
      const updatedMessages = [
        ...newMessages,
        { sender: 'ai', text: aiReply },
      ];
  
      setMessages(updatedMessages);
      setCollapsedMessageIndex(updatedMessages.length - 1);
      setMessageCount((prev) => prev + 1);
      setSelectedTopicId(null);
    } catch (err) {
      console.error('❌ Error from /askTheChartAiChat:', err);

  try {
    const db = getFirestore();
    await addDoc(collection(db, 'user_aiagent_ask_the_chart_interactions'), {
      userid: userId,
      chatsessionid: chatSessionId,
      usermessage: userMessage,
      airesponse: `[system] error response: ${err?.response?.data?.message || err?.message || 'Unknown error'}`,
      chartcontext: chartContextPrompt,
      charttype,
      instrument,
      timeframe,
      modelused: 'api-error',
      messageid: messageId,
      intent: 'ask the chart',
      timestamp: serverTimestamp(),
      debuginfo: {
        status: err?.response?.status || null,
        data: err?.response?.data || null,
        headers: err?.response?.headers || null,
      },
    });
  } catch (logErr) {
    console.error('❌ Failed to log error interaction to Firestore:', logErr);
  }
      
      
      

      setMessages([
        ...newMessages,
        { sender: 'ai', text: '⚠️ Something went wrong. Please try again later.' },
      ]);
    } finally {
      setLoading(false);
    }
  };

 














  
  

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header
        className="d-flex justify-content-between align-items-center border-0"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <h5 className="fw-bold mb-0" style={{ color: '#FF7C24' }}>
          Test your Prop Funding Strategies
        </h5>
        <Button
          variant="link"
          onClick={onClose}
          aria-label="Close"
          style={{ fontSize: '1.5rem', color: '#232830' }}
        >
          ✖️
        </Button>
      </Modal.Header>

      {/* <Modal.Body
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          backgroundColor: '#FFFFFF',
          padding: '1rem',
        }}
      > */}

<Modal.Body
  onScroll={handleScroll}
  style={{
    maxHeight: '400px',
    overflowY: 'auto',
    backgroundColor: '#FFFFFF',
    padding: '1rem',
    position: 'relative',
  }}
>
  {messageCount === 0 && (
   <AskChartTopicsPropFunding
   onTopicClick={(topic) => {
     setUserInput(topic.question);
     setSelectedTopicId(topic.id);
   }}
 />
 
  )}




        
        <div className="d-flex flex-column gap-3">

        {messages.map((msg, i) => {
  const isUpgradeMessage = typeof msg.text === 'string' && msg.text.includes('🚀');
  const isCollapsed = collapsedMessageIndex !== null && i === collapsedMessageIndex && !isUpgradeMessage;


  const formattedText = formatAIMessage(msg.text || '');

  if (msg.sender === 'ai' && isCollapsed) {
    const preview = formattedText.split(/<br\s*\/?>/).slice(0, 25).join('<br/>');

    return (
      <div
        key={i}
        style={{
          alignSelf: 'flex-start',
          backgroundColor: '#232830',
          color: '#FFFFFF',
          padding: '12px 16px',
          borderRadius: '16px',
          maxWidth: '80%',
          fontSize: '16px',
          position: 'relative',
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: preview + '<br/>...' }} />
        <div
         onClick={() =>
          setCollapsedMessageIndex((prev) => (prev === i ? null : i))
        }
        

          style={{
            position: 'absolute',
            bottom: '10px',
            right: '12px',
            cursor: 'pointer',
            fontSize: '24px',
            backgroundColor: '#FF7C24',
            color: '#fff',
            padding: '4px 10px',
            borderRadius: '20px',
            boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
          }}
        >
          ⬇️
        </div>
      </div>
    );
  }

return (
  <div key={i} style={{ display: 'flex', flexDirection: 'column' }}>
    <MessageContainer sender={msg.sender}>
      {msg.sender === 'ai'
        ? <div dangerouslySetInnerHTML={{ __html: formattedText }} />
        : msg.text}
    </MessageContainer>

    {/* 👍 👎 Feedback - only for AI messages that are not upgrade messages */}
    {msg.sender === 'ai' && !isUpgradeMessage && (
      <div style={{ marginTop: '6px', textAlign: 'right', marginRight: '12px' }}>
        <span
          style={{ cursor: 'pointer', marginRight: '10px' }}
          onClick={() => handleFeedback('upvote', msg.text)}
        >👍</span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => handleFeedback('downvote', msg.text)}
        >👎</span>
      </div>
    )}
  </div>
);


})}




{/* {loading && (
    <div
      style={{
        alignSelf: 'flex-start',
        backgroundColor: '#f0f0f0',
        color: '#232830',
        padding: '10px 16px',
        borderRadius: '16px',
        fontSize: '16px',
        fontStyle: 'italic',
        maxWidth: '60%',
      }}
    >
      I'm thinking...
    </div>
  )} */}

{loading && (
  <div
    style={{
      alignSelf: 'flex-start',
      backgroundColor: '#f0f0f0',
      color: '#232830',
      padding: '10px 16px',
      borderRadius: '16px',
      fontSize: '16px',
      fontStyle: 'italic',
      maxWidth: '60%',
      animation: 'blink 1s linear infinite',
    }}
  >
    I'm thinking...
  </div>
)}



          <div ref={chatEndRef}></div>
          {isScrolledUp && (
  <div
    onClick={() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' })}
    style={{
      position: 'absolute',
      bottom: '12px',
      right: '16px',
      backgroundColor: '#FF7C24',
      color: '#fff',
      borderRadius: '50%',
      width: '36px',
      height: '36px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      zIndex: 10,
      fontSize: '18px',
    }}
    title="Scroll to bottom"
  >
    ⬇️
  </div>
)}




        </div>
      </Modal.Body>

      <Modal.Footer
        className="border-0"
        style={{
          flexDirection: 'column',
          gap: '10px',
          backgroundColor: '#232830',
          width: '100%',
          padding: '20px',
        }}
      >
{messageCount < MAX_MESSAGES ? (
  <div style={{ width: '100%' }}>
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      marginBottom: '6px'
    }}>
<p
  style={{
    color: remainingMessages === 1 ? '#FF4C4C' : '#FF7C24',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '6px 12px',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '8px',
    display: 'inline-block',
    animation: remainingMessages === 1 ? 'bounceFlash 0.6s ease-in-out' : 'none',
  }}
>
  🧠 You have {remainingMessages} free {remainingMessages === 1 ? 'credit' : 'credits'} left
</p>
    </div>

    <div style={{ display: 'flex', gap: '10px', width: '100%', flexWrap: 'nowrap' }}>
      <Form.Control
        type="text"
        placeholder="Ask a question..."
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        disabled={loading}
        style={{
          flex: 1,
          minHeight: '50px',
          backgroundColor: '#FFFFFF',
          color: '#232830',
          borderRadius: '12px',
          border: '1px solid #CED4DA',
          fontSize: '16px',
          padding: '0.75rem',
        }}
      />
      <StyledSendButton
        onClick={handleSendMessage}
        disabled={loading || !userInput.trim()}
      >
        {loading ? '...' : 'Send'}
      </StyledSendButton>
    </div>
  </div>
        ) : (
          <UpgradeContainer>
  <p style={{ fontWeight: 'bold', fontSize: '17px', color: '#232830' }}>
    🚀 You’ve used up the free limit. Upgrade to FinTorro Pro to unlock full chart AI access!
  </p>
  <p style={{ fontWeight: 'bold', fontSize: '16px', marginTop: '15px' }}>
    Upgrade to FinTorro Pro and get:
  </p>
  <ul className="list-unstyled" style={{ fontSize: '15px', lineHeight: '1.6', color: '#232830' }}>
    <li>• Unlimited Lessons & Practice</li>
    <li>• Learn with AI</li>
    <li>• 10,000+ Interactive Lessons</li>
    <li>• Crypto, Forex, Stocks & More</li>
    <li>• Join Challenges & Earn Rewards</li>
  </ul>
  <UpgradeButton onClick={() => window.open('https://buy.stripe.com/eVa29y1Ig8zsgFycMZ')}>
    Upgrade to Pro
  </UpgradeButton>
</UpgradeContainer>

        )}
      </Modal.Footer>

      <p style={{
  fontSize: '13px',
  textAlign: 'center',
  color: '#6c757d',
  padding: '10px 20px',
  marginTop: '8px',
}}>
  🤖 AI can make mistakes. Please use with discretion.
</p>

    </Modal>
  );
};

export default AskLiveChartPropFunding;